import { Box, Skeleton } from '@holbonkit/ui'

import styles from './withdrawal-smz-loading.module.scss'

export const WithdrawalSmzLoading = () => {
    return (
        <Box className={styles['loading']}>
            <Box className={styles['loading__header']}>
                <Skeleton style={{ width: 165, height: 22 }} />
                <Skeleton style={{ width: 44, height: 48, margin: '2px 0' }} />
                <Skeleton style={{ width: 200, height: 19, marginBottom: 16 }} />
                <Skeleton style={{ width: 156, height: 40 }} />
            </Box>
            <Box className={styles['loading__content']} style={{ height: 65 }} />
            <Box className={styles['loading__content']}>
                <Skeleton style={{ width: 120, height: 120, marginBottom: 20 }} />
                <Skeleton style={{ width: '100%', height: 32, marginBottom: 5 }} />
                <Skeleton style={{ width: '100%', height: 44, marginBottom: 20 }} />
                <Skeleton style={{ width: 120, height: 40 }} />
            </Box>
            <Box className={styles['loading__content']} style={{ height: 48 }} />
        </Box>
    )
}
